import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { Timesheet } from '../../types';
import { getWeeklyTimesheetWeekStart } from '../../utils/getWeeklyTimesheetWeekStart';

export type PendingMonthViewContextValue = {
  viewedYear: number;
  viewedMonth: number;
  /** Full list from useTimesheets (same reference as parent). */
  allTimesheets: Timesheet[] | undefined;
};

const PendingMonthViewContext = createContext<PendingMonthViewContextValue | null>(null);

export function PendingMonthViewProvider({
  viewedYear,
  viewedMonth,
  allTimesheets,
  children,
}: PendingMonthViewContextValue & { children: ReactNode }) {
  const value = useMemo(
    () => ({ viewedYear, viewedMonth, allTimesheets }),
    [viewedYear, viewedMonth, allTimesheets]
  );
  return (
    <PendingMonthViewContext.Provider value={value}>{children}</PendingMonthViewContext.Provider>
  );
}

export function usePendingMonthView(): PendingMonthViewContextValue | null {
  return useContext(PendingMonthViewContext);
}

export function timesheetWeekStartsInCalendarMonth(
  ts: Timesheet,
  year: number,
  month: number
): boolean {
  const k = getWeeklyTimesheetWeekStart(ts).split('T')[0];
  if (!k) return false;
  const [y, m] = k.split('-').map(Number);
  return y === year && m === month;
}
